import { IntentClassifierModel } from '@/lib/models/classifier';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import PhraseCard from './phrase-card';
import PhraseUploader from './phrase-uploader';
import Text from '@/components/text';

interface Props {
  classifier: IntentClassifierModel;
  onUpload: () => void;
}

const PhraseSetForm: FC<Props> = ({ classifier, onUpload }) => {
  return (
    <Stack gap={4}>
      <PhraseCard classifier={classifier} />
      <Box width="100%">
        <Box mb={1}>
          <Text bold>Upload New Example Messages File</Text>
        </Box>
        <Text>
          Please upload either a TXT or CSV file with one message per line. The maximum file size is
          2MB, and messages must be unique within the file.
        </Text>

        <Box mt={2}>
          <PhraseUploader classifier={classifier} onUpload={onUpload} />
        </Box>
      </Box>
    </Stack>
  );
};

export default PhraseSetForm;
